import React from 'react';
import Button from '../../../../shared/components/Button/Button';
import Card from '../../../../shared/components/Card/Card';
import Chip from '../../../../shared/components/Chip/Chip';
import IconButton from '../../../../shared/components/IconButton/IconButton';
import { getWikiDocumentVisual, StarBorderIcon, StarIcon } from './WikiIcons';
import { formatWikiDate } from '../wiki.date';

const statusVariant = {
  Publié: 'success',
  Brouillon: 'neutral',
  'À valider': 'warning',
  'À réviser': 'danger',
  Archive: 'neutral',
};

function WikiArticleCard({
  article,
  getCategoryLabel,
  isFavorite = false,
  onOpen,
  onToggleFavorite,
}) {
  const category = getCategoryLabel(article.category);
  const { Icon: DocumentIcon, tone } = getWikiDocumentVisual(article.type);

  return (
    <Card
      className="wiki-article-card"
      compact
      header={(
        <div className="wiki-card-chip-row">
          <span className={`wiki-card-document-icon wiki-icon-tone--${tone}`} aria-hidden="true"><DocumentIcon fontSize="small" /></span>
          <Chip size="small" variant="info">{article.type}</Chip>
          <Chip size="small" variant={statusVariant[article.status] || 'neutral'}>{article.status}</Chip>
        </div>
      )}
      actions={onToggleFavorite && (
        <IconButton
          active={isFavorite}
          ariaLabel={isFavorite ? 'Retirer des favoris' : 'Ajouter aux favoris'}
          size="small"
          tooltip={isFavorite ? 'Retirer des favoris' : 'Ajouter aux favoris'}
          onClick={() => onToggleFavorite(article.id)}
        >
          {isFavorite ? <StarIcon fontSize="small" /> : <StarBorderIcon fontSize="small" />}
        </IconButton>
      )}
      footer={(
        <dl className="wiki-card-footer">
          <div><dt>Catégorie</dt><dd>{category}</dd></div>
          <div><dt>Référent</dt><dd>{article.owner || 'Non renseigné'}</dd></div>
          <div><dt>Mise à jour</dt><dd>{formatWikiDate(article.updatedAt)}</dd></div>
        </dl>
      )}
    >
      <div className="wiki-article-card__copy">
        <Button className="wiki-card-title-button" variant="ghost" onClick={() => onOpen(article)}>
          <strong className="wiki-card-title">{article.title}</strong>
        </Button>
        <span className="wiki-card-summary">{article.summary || 'Aucun résumé disponible.'}</span>
      </div>
    </Card>
  );
}

export default WikiArticleCard;
